/* src/app/admin-dashboard/vm-machine/channel-list/channel-list.component.css */
mat-grid-tile {
  background: lightblue;
}
.col {
  margin: 2px;
  min-height: 80px;
  color: grey;
  cursor: pointer;
  flex-grow: 1;
}
.selected {
  color: black;
  border: 2px solid #563d7c !important;
  border-radius: 5px;
}
.unapplied {
  color: red;
  margin-bottom: -5px;
  margin-left: 5px;
}
.col:hover {
  color: black;
  border: 2px solid #aba6b3;
  border-radius: 5px;
}
.row {
  flex-grow: 1;
}
.container {
  margin: 0px;
  margin-top: 10px;
  margin-bottom: 0px;
  height: 600px;
  width: 99%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-tooltip {
  color: yellow !important;
}
.soldOut {
  color: red;
  position: absolute;
  z-index: 6;
  position: absolute;
  bottom: 0px;
  left: 20px;
}
.text {
  position: absolute;
  top: 0px;
  left: 2px;
}
.quantity {
  z-index: 6;
  position: absolute;
  bottom: 0px;
  left: 2px;
  color: rgb(220, 103, 103);
}
.nameOfProduct {
  z-index: 6;
  position: absolute;
  padding-right: 2px;
  top: 2em;
  line-height: 1em;
  left: 5px;
  font-size: 0.7em;
  width: 100%;
  word-wrap: break-word;
  color: rgb(220, 103, 103);
}
.selection {
  z-index: 6;
  position: absolute;
  top: 1px;
  right: 4px;
}
.productType {
  z-index: 6;
  position: absolute;
  top: 1px;
  left: 4px;
  font-size: 0.7em;
  color: grey;
}
.card-img-top {
  position: absolute;
  bottom: 0px;
  right: 0px;
  max-width: 60px;
  width: 60%;
  max-height: 70%;
  border-radius: 0px 0px 5px 0px;
}
.shift-product {
  position: absolute;
  top: 0px;
  right: 0px;
  color: lightgray;
}
#x {
  position: absolute;
  color: lightgray;
  top: -15px;
  right: -15px;
}
@media only screen and (max-width: 600px) {
  .nameOfProduct {
    font-size: 0.7em;
    color: black;
  }
  .container {
    margin: 0px;
    padding: 0px;
  }
  .selection {
    font-size: 0.9em;
  }
  .col:hover {
    color: black;
    border: none;
    border-radius: 5px;
  }
  .productType {
    display: none;
  }
}
/*# sourceMappingURL=channel-list.component.css.map */
